import modelBaseV2 from "../model-base-v2.model";

const ImeiSnInputModel = {
  getBackDateLimitDate: () => {
    return modelBaseV2.get("/api/user/backDateLimitDate");
  },

  registerDataInput: (body) => {
    return modelBaseV2.post("/api/datainput/registration", {
      body,
    });
  },

  downloadResult: (fileId, filename) => {
    return modelBaseV2.getDownload(
      "/api/file/temp/:fileId",
      {
        params: { fileId },
      },
      filename
    );
  },

  checkIsRAOrDealer: () => {
    return modelBaseV2.get("/api/user/isRADealer");
  },

  checkIsAcceptConsentBefore: () => {
    return modelBaseV2.get("/api/datainput/isRADealerConsentAddYN");
  },

  getConsentInfo: () => {
    return modelBaseV2.get("/api/user/isRADealerAndConsentYN");
  },
};

export default ImeiSnInputModel;
